export const QuickInputType = {
    Image: "image",
    Text: "text",
    Audio: "audio",
    Document: "document",
    Video: "video",
    ImageCanvas: "image_canvas",
    Csv: "csv"
};